var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgV2RevampedLoginCheckbox(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.22222 20C1.61111 20 1.08778 19.7826 0.652222 19.3478C0.217407 18.9122 0 18.3889 0 17.7778V2.22222C0 1.61111 0.217407 1.08778 0.652222 0.652222C1.08778 0.217407 1.61111 0 2.22222 0H17.7778C18.3889 0 18.9122 0.217407 19.3478 0.652222C19.7826 1.08778 20 1.61111 20 2.22222V17.7778C20 18.3889 19.7826 18.9122 19.3478 19.3478C18.9122 19.7826 18.3889 20 17.7778 20H2.22222ZM2.22222 17.7778H17.7778V2.22222H2.22222V17.7778Z",
    fill: "#822AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2RevampedLoginCheckbox);
export default __webpack_public_path__ + "static/media/v2_revamped_login_checkbox.abbc5edee91ba3f7f3cc38c042607ef3.svg";
export { ForwardRef as ReactComponent };